import { mapGetters } from 'vuex';

export default {
  name: 'EcsSideBarPendingInteractionMixin',

  computed: {
    ...mapGetters('INTERACTIONS', ['getPendingInteractions']),

    ...mapGetters('SETTINGS', ['preferencesSettings']),

    displayPendingInteraction() {
      return (
        this.getPendingInteractions &&
        this.getPendingInteractions.length > 0 &&
        this.preferencesSettings &&
        this.preferencesSettings.incomingInteractionDisplay !== 'banner'
      );
    }
  }
};
